/**
 * Platform Abstraction Layer
 * Exports the appropriate adapter based on runtime environment
 */

import type { PlatformAPI } from './types';
import { webAdapter } from './web-adapter';
import { electronAdapter, isElectronEnvironment } from './electron-adapter';

/**
 * Runtime platform API
 * Returns electronAdapter if running in Electron, webAdapter otherwise
 */
export const platform: PlatformAPI = isElectronEnvironment() ? electronAdapter : webAdapter;

/**
 * Check if running in Electron environment
 */
export const isElectron = isElectronEnvironment();

/**
 * Platform exports
 */
export { webAdapter, electronAdapter };
export * from './types';
export { isElectronEnvironment } from './electron-adapter';

// Default export
export default platform;
